/**
 * AUTO-GENERATED by tools/curriculum/generate-typescript-react-nextjs-static-aliases.ts.
 * Source: content/curriculum-restructures/typescript-react-nextjs-v1/plan.json
 * Static alias contract SHA-256: aa8ac5696dcbef7b7f06ca9c8f40f3bcc478e0f0ba504d5925e7fabc8cf55de4
 *
 * Old lesson keys remain the only enumerable static-asset identities. New keys
 * are lookup aliases to the same objects and CONTENT records, never copies.
 * Do not edit this file by hand.
 */

export interface TypescriptReactNextjsCourseSplitLessonAlias {
  lessonId: string;
  oldKey: string;
  newKey: string;
  oldCourseSlug: string;
  newCourseSlug: string;
  lessonSlug: string;
}

export const TYPESCRIPT_REACT_NEXTJS_STATIC_ALIAS_COUNT = 152 as const;
export const TYPESCRIPT_REACT_NEXTJS_STATIC_ALIAS_FINGERPRINT =
  "aa8ac5696dcbef7b7f06ca9c8f40f3bcc478e0f0ba504d5925e7fabc8cf55de4" as const;

export const TYPESCRIPT_REACT_NEXTJS_LESSON_ALIASES = Object.freeze([
  {
    lessonId: "110352f0-ef1c-4afc-9c2a-444b23eaadff",
    oldKey: "nextjs-intro/nx-api-get",
    newKey: "nextjs-fullstack/nx-api-get",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-fullstack",
    lessonSlug: "nx-api-get",
  },
  {
    lessonId: "7b3c201d-fa81-42a6-9537-193497b5844a",
    oldKey: "nextjs-intro/nx-api-post",
    newKey: "nextjs-fullstack/nx-api-post",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-fullstack",
    lessonSlug: "nx-api-post",
  },
  {
    lessonId: "66318b89-6b3e-4429-9967-41cf8717d704",
    oldKey: "nextjs-intro/nx-async-components",
    newKey: "nextjs-fullstack/nx-async-components",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-fullstack",
    lessonSlug: "nx-async-components",
  },
  {
    lessonId: "b7ff0991-2514-4afa-b88d-f522fc47eb37",
    oldKey: "nextjs-intro/nx-boundary-design",
    newKey: "nextjs-fullstack/nx-boundary-design",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-fullstack",
    lessonSlug: "nx-boundary-design",
  },
  {
    lessonId: "b79504d1-9b16-48b7-bce5-ff27c34254fd",
    oldKey: "nextjs-intro/nx-build-basics",
    newKey: "nextjs-production/nx-build-basics",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-production",
    lessonSlug: "nx-build-basics",
  },
  {
    lessonId: "274e90c5-c55b-458f-a5a1-cfcf0f175fed",
    oldKey: "nextjs-intro/nx-caching-basics",
    newKey: "nextjs-fullstack/nx-caching-basics",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-fullstack",
    lessonSlug: "nx-caching-basics",
  },
  {
    lessonId: "66964173-845f-4056-a195-d4a62e9cf352",
    oldKey: "nextjs-intro/nx-ch4-build",
    newKey: "nextjs-fullstack/nx-ch4-build",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-fullstack",
    lessonSlug: "nx-ch4-build",
  },
  {
    lessonId: "4c41a586-e94e-45e6-8213-d7c6490bf1df",
    oldKey: "nextjs-intro/nx-ch4-quiz",
    newKey: "nextjs-fullstack/nx-ch4-quiz",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-fullstack",
    lessonSlug: "nx-ch4-quiz",
  },
  {
    lessonId: "411c0f6b-1ed7-471e-b546-8b69018475b8",
    oldKey: "nextjs-intro/nx-ch5-build",
    newKey: "nextjs-fullstack/nx-ch5-build",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-fullstack",
    lessonSlug: "nx-ch5-build",
  },
  {
    lessonId: "ba0c549a-7ec4-405c-bb9b-f9c450b75fbc",
    oldKey: "nextjs-intro/nx-ch5-quiz",
    newKey: "nextjs-fullstack/nx-ch5-quiz",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-fullstack",
    lessonSlug: "nx-ch5-quiz",
  },
  {
    lessonId: "eb012da0-3a86-46f5-b676-f27e13b9e5d2",
    oldKey: "nextjs-intro/nx-ch6-build",
    newKey: "nextjs-fullstack/nx-ch6-build",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-fullstack",
    lessonSlug: "nx-ch6-build",
  },
  {
    lessonId: "8bc380eb-f3ee-4906-a5db-6ef944ee58b2",
    oldKey: "nextjs-intro/nx-ch6-quiz",
    newKey: "nextjs-fullstack/nx-ch6-quiz",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-fullstack",
    lessonSlug: "nx-ch6-quiz",
  },
  {
    lessonId: "1dbdc81b-6b87-43c8-bce2-15aa592daf27",
    oldKey: "nextjs-intro/nx-ch7-build",
    newKey: "nextjs-production/nx-ch7-build",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-production",
    lessonSlug: "nx-ch7-build",
  },
  {
    lessonId: "17d234d3-cffb-451b-a3e1-c979cf113e41",
    oldKey: "nextjs-intro/nx-ch7-quiz",
    newKey: "nextjs-production/nx-ch7-quiz",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-production",
    lessonSlug: "nx-ch7-quiz",
  },
  {
    lessonId: "c466450f-5dfd-4a2d-a039-c3ed075da9b0",
    oldKey: "nextjs-intro/nx-composition-rsc",
    newKey: "nextjs-fullstack/nx-composition-rsc",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-fullstack",
    lessonSlug: "nx-composition-rsc",
  },
  {
    lessonId: "55fdd66d-5d36-4322-ae37-db4038ed9c71",
    oldKey: "nextjs-intro/nx-deploy-managed",
    newKey: "nextjs-production/nx-deploy-managed",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-production",
    lessonSlug: "nx-deploy-managed",
  },
  {
    lessonId: "e23150c7-5d31-45f4-8341-b98591b579c7",
    oldKey: "nextjs-intro/nx-deploy-self",
    newKey: "nextjs-production/nx-deploy-self",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-production",
    lessonSlug: "nx-deploy-self",
  },
  {
    lessonId: "3558df87-f3b9-4687-9531-d493f3b9099a",
    oldKey: "nextjs-intro/nx-dynamic-metadata",
    newKey: "nextjs-production/nx-dynamic-metadata",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-production",
    lessonSlug: "nx-dynamic-metadata",
  },
  {
    lessonId: "dec879d5-2474-4207-bcec-69956b81a99c",
    oldKey: "nextjs-intro/nx-dynamic-routes",
    newKey: "nextjs-fullstack/nx-dynamic-routes",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-fullstack",
    lessonSlug: "nx-dynamic-routes",
  },
  {
    lessonId: "f70e1d28-327d-463e-a1ec-fb961eb72fdd",
    oldKey: "nextjs-intro/nx-final-check",
    newKey: "nextjs-production/nx-final-check",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-production",
    lessonSlug: "nx-final-check",
  },
  {
    lessonId: "22704c00-f460-421b-9b7b-644efb88f0be",
    oldKey: "nextjs-intro/nx-final-extend",
    newKey: "nextjs-production/nx-final-extend",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-production",
    lessonSlug: "nx-final-extend",
  },
  {
    lessonId: "da4a06fa-f090-48da-9395-0e4e10c03596",
    oldKey: "nextjs-intro/nx-final-next",
    newKey: "nextjs-production/nx-final-next",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-production",
    lessonSlug: "nx-final-next",
  },
  {
    lessonId: "81950e86-04cf-4e6c-85d7-8096011c7c5d",
    oldKey: "nextjs-intro/nx-fonts",
    newKey: "nextjs-production/nx-fonts",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-production",
    lessonSlug: "nx-fonts",
  },
  {
    lessonId: "5da1d005-89c8-4e21-9d21-ad206ccfcb03",
    oldKey: "nextjs-intro/nx-form-submit-nextjs",
    newKey: "nextjs-fullstack/nx-form-submit-nextjs",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-fullstack",
    lessonSlug: "nx-form-submit-nextjs",
  },
  {
    lessonId: "d033cf59-805b-49e6-a426-f167ac823519",
    oldKey: "nextjs-intro/nx-metadata-basics",
    newKey: "nextjs-production/nx-metadata-basics",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-production",
    lessonSlug: "nx-metadata-basics",
  },
  {
    lessonId: "993717af-cf23-4ad0-b4a4-5845448c0e44",
    oldKey: "nextjs-intro/nx-next-image",
    newKey: "nextjs-production/nx-next-image",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-production",
    lessonSlug: "nx-next-image",
  },
  {
    lessonId: "937625ee-d575-4b54-a996-e3bb00b2fb61",
    oldKey: "nextjs-intro/nx-not-found-nextjs",
    newKey: "nextjs-fullstack/nx-not-found-nextjs",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-fullstack",
    lessonSlug: "nx-not-found-nextjs",
  },
  {
    lessonId: "ee0eae0a-2adc-4f0d-8b76-91d9b232ccdf",
    oldKey: "nextjs-intro/nx-ogp",
    newKey: "nextjs-production/nx-ogp",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-production",
    lessonSlug: "nx-ogp",
  },
  {
    lessonId: "1593bdcd-8af5-4818-9e77-66419cfda340",
    oldKey: "nextjs-intro/nx-params-props",
    newKey: "nextjs-fullstack/nx-params-props",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-fullstack",
    lessonSlug: "nx-params-props",
  },
  {
    lessonId: "94f88fa9-f4ba-4f84-a2ce-29a7b11be73c",
    oldKey: "nextjs-intro/nx-route-handlers",
    newKey: "nextjs-fullstack/nx-route-handlers",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-fullstack",
    lessonSlug: "nx-route-handlers",
  },
  {
    lessonId: "ac22dbbc-7456-44cc-9797-5255d71f7c96",
    oldKey: "nextjs-intro/nx-search-server",
    newKey: "nextjs-fullstack/nx-search-server",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-fullstack",
    lessonSlug: "nx-search-server",
  },
  {
    lessonId: "7c55d095-0842-4388-883d-2112ac2ce407",
    oldKey: "nextjs-intro/nx-server-actions-intro",
    newKey: "nextjs-fullstack/nx-server-actions-intro",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-fullstack",
    lessonSlug: "nx-server-actions-intro",
  },
  {
    lessonId: "99c19a49-d20f-4301-9759-8dd87012dfd3",
    oldKey: "nextjs-intro/nx-server-components",
    newKey: "nextjs-fullstack/nx-server-components",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-fullstack",
    lessonSlug: "nx-server-components",
  },
  {
    lessonId: "79112081-1689-457c-9b6c-0e9442c077c6",
    oldKey: "nextjs-intro/nx-server-fetch",
    newKey: "nextjs-fullstack/nx-server-fetch",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-fullstack",
    lessonSlug: "nx-server-fetch",
  },
  {
    lessonId: "6afb5038-10d9-4442-acc5-f45a945a27a3",
    oldKey: "nextjs-intro/nx-two-worlds",
    newKey: "nextjs-fullstack/nx-two-worlds",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-fullstack",
    lessonSlug: "nx-two-worlds",
  },
  {
    lessonId: "952aefee-5370-45eb-82d8-1974cefc6f37",
    oldKey: "nextjs-intro/nx-use-client",
    newKey: "nextjs-fullstack/nx-use-client",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-fullstack",
    lessonSlug: "nx-use-client",
  },
  {
    lessonId: "46d218f3-b309-4e2a-a8a1-9c602f2790d3",
    oldKey: "nextjs-intro/nx-when-client",
    newKey: "nextjs-fullstack/nx-when-client",
    oldCourseSlug: "nextjs-intro",
    newCourseSlug: "nextjs-fullstack",
    lessonSlug: "nx-when-client",
  },
  {
    lessonId: "c5abebcd-6044-4244-89b3-50f6f861607b",
    oldKey: "react-intro/ri-ch4-build",
    newKey: "react-state-ui/ri-ch4-build",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-state-ui",
    lessonSlug: "ri-ch4-build",
  },
  {
    lessonId: "cd0ef3ad-67f7-4cf4-912c-f197e3fca319",
    oldKey: "react-intro/ri-ch4-quiz",
    newKey: "react-state-ui/ri-ch4-quiz",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-state-ui",
    lessonSlug: "ri-ch4-quiz",
  },
  {
    lessonId: "b890eac5-85cb-4a1e-bbbd-bbc685ed3e75",
    oldKey: "react-intro/ri-ch5-build",
    newKey: "react-state-ui/ri-ch5-build",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-state-ui",
    lessonSlug: "ri-ch5-build",
  },
  {
    lessonId: "30e51e1e-f329-44b1-943b-a874fe992b9b",
    oldKey: "react-intro/ri-ch5-quiz",
    newKey: "react-state-ui/ri-ch5-quiz",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-state-ui",
    lessonSlug: "ri-ch5-quiz",
  },
  {
    lessonId: "847323ac-dff5-4f1d-93d0-eca3052244c6",
    oldKey: "react-intro/ri-ch6-build",
    newKey: "react-state-ui/ri-ch6-build",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-state-ui",
    lessonSlug: "ri-ch6-build",
  },
  {
    lessonId: "19ceb6bc-6dad-4c67-8457-3a4467cc6916",
    oldKey: "react-intro/ri-ch6-quiz",
    newKey: "react-state-ui/ri-ch6-quiz",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-state-ui",
    lessonSlug: "ri-ch6-quiz",
  },
  {
    lessonId: "a0fa6331-650a-426c-a0bd-7378b8098300",
    oldKey: "react-intro/ri-ch7-build",
    newKey: "react-effects-architecture/ri-ch7-build",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-effects-architecture",
    lessonSlug: "ri-ch7-build",
  },
  {
    lessonId: "59dfd90a-ecdb-444e-963b-ec27845f16bd",
    oldKey: "react-intro/ri-ch7-quiz",
    newKey: "react-effects-architecture/ri-ch7-quiz",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-effects-architecture",
    lessonSlug: "ri-ch7-quiz",
  },
  {
    lessonId: "f9635ab1-9986-449a-9ff1-c306de4f122d",
    oldKey: "react-intro/ri-ch8-build",
    newKey: "react-effects-architecture/ri-ch8-build",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-effects-architecture",
    lessonSlug: "ri-ch8-build",
  },
  {
    lessonId: "121e2d33-d1b6-4ad3-9527-7f6bfe1505ba",
    oldKey: "react-intro/ri-ch8-quiz",
    newKey: "react-effects-architecture/ri-ch8-quiz",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-effects-architecture",
    lessonSlug: "ri-ch8-quiz",
  },
  {
    lessonId: "1e9846d9-6464-4759-9fda-905e96626863",
    oldKey: "react-intro/ri-component-tree",
    newKey: "react-effects-architecture/ri-component-tree",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-effects-architecture",
    lessonSlug: "ri-component-tree",
  },
  {
    lessonId: "b2947680-92c2-4052-bd04-99ce9a44d6f3",
    oldKey: "react-intro/ri-conditional-and",
    newKey: "react-state-ui/ri-conditional-and",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-state-ui",
    lessonSlug: "ri-conditional-and",
  },
  {
    lessonId: "19ac19da-ef9d-428d-bdac-b3641147b320",
    oldKey: "react-intro/ri-conditional-ternary",
    newKey: "react-state-ui/ri-conditional-ternary",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-state-ui",
    lessonSlug: "ri-conditional-ternary",
  },
  {
    lessonId: "7f25b9f7-8af7-4d9a-a19a-a01ffc63204e",
    oldKey: "react-intro/ri-controlled-inputs",
    newKey: "react-state-ui/ri-controlled-inputs",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-state-ui",
    lessonSlug: "ri-controlled-inputs",
  },
  {
    lessonId: "bbc4a46c-2bc4-4781-bc1c-6657c232a54c",
    oldKey: "react-intro/ri-dependencies",
    newKey: "react-effects-architecture/ri-dependencies",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-effects-architecture",
    lessonSlug: "ri-dependencies",
  },
  {
    lessonId: "8770031c-d4b5-4efe-b289-eef76a6d5b5a",
    oldKey: "react-intro/ri-document-title",
    newKey: "react-effects-architecture/ri-document-title",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-effects-architecture",
    lessonSlug: "ri-document-title",
  },
  {
    lessonId: "c94654b9-6b25-433b-8197-7aded03d4eae",
    oldKey: "react-intro/ri-empty-states",
    newKey: "react-state-ui/ri-empty-states",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-state-ui",
    lessonSlug: "ri-empty-states",
  },
  {
    lessonId: "2ec2aab6-04b8-40e0-a312-47c91d6fc3ae",
    oldKey: "react-intro/ri-event-handlers",
    newKey: "react-state-ui/ri-event-handlers",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-state-ui",
    lessonSlug: "ri-event-handlers",
  },
  {
    lessonId: "23ddceb4-31d6-4ce2-ab06-46bfc13f00cb",
    oldKey: "react-intro/ri-event-object-react",
    newKey: "react-state-ui/ri-event-object-react",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-state-ui",
    lessonSlug: "ri-event-object-react",
  },
  {
    lessonId: "7cfb4062-898f-4248-85eb-9493cbaaed5a",
    oldKey: "react-intro/ri-filter-ui",
    newKey: "react-state-ui/ri-filter-ui",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-state-ui",
    lessonSlug: "ri-filter-ui",
  },
  {
    lessonId: "158f13a6-476a-4e7e-aab2-fd5ba293d53c",
    oldKey: "react-intro/ri-final-compare",
    newKey: "react-effects-architecture/ri-final-compare",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-effects-architecture",
    lessonSlug: "ri-final-compare",
  },
  {
    lessonId: "617bde25-7db2-470c-8d7f-d218f227d4d5",
    oldKey: "react-intro/ri-final-extend",
    newKey: "react-effects-architecture/ri-final-extend",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-effects-architecture",
    lessonSlug: "ri-final-extend",
  },
  {
    lessonId: "30770f94-1386-4861-82ee-39eb706755e6",
    oldKey: "react-intro/ri-final-memo",
    newKey: "react-effects-architecture/ri-final-memo",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-effects-architecture",
    lessonSlug: "ri-final-memo",
  },
  {
    lessonId: "29dd6954-8058-41c0-86dd-6bdc8d33cd90",
    oldKey: "react-intro/ri-final-next",
    newKey: "react-effects-architecture/ri-final-next",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-effects-architecture",
    lessonSlug: "ri-final-next",
  },
  {
    lessonId: "a170bba5-3f0c-4f3c-a832-21a7ca11fb05",
    oldKey: "react-intro/ri-final-rebuild",
    newKey: "react-effects-architecture/ri-final-rebuild",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-effects-architecture",
    lessonSlug: "ri-final-rebuild",
  },
  {
    lessonId: "8c67bda9-f9ca-4f01-81dc-524b3c23c315",
    oldKey: "react-intro/ri-folder-structure",
    newKey: "react-effects-architecture/ri-folder-structure",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-effects-architecture",
    lessonSlug: "ri-folder-structure",
  },
  {
    lessonId: "86e7cc36-7c23-4692-9c4e-e0e211a9e430",
    oldKey: "react-intro/ri-form-submit",
    newKey: "react-state-ui/ri-form-submit",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-state-ui",
    lessonSlug: "ri-form-submit",
  },
  {
    lessonId: "e7d82b0b-5639-4f3c-a0d6-44d165cb8585",
    oldKey: "react-intro/ri-keys",
    newKey: "react-state-ui/ri-keys",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-state-ui",
    lessonSlug: "ri-keys",
  },
  {
    lessonId: "bad19b65-9fda-4a6e-95b4-a78a43596111",
    oldKey: "react-intro/ri-lifting-state",
    newKey: "react-effects-architecture/ri-lifting-state",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-effects-architecture",
    lessonSlug: "ri-lifting-state",
  },
  {
    lessonId: "c6460a67-347e-4b1a-a19f-1c5a886ee4df",
    oldKey: "react-intro/ri-multiple-state",
    newKey: "react-state-ui/ri-multiple-state",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-state-ui",
    lessonSlug: "ri-multiple-state",
  },
  {
    lessonId: "d5077abe-45bd-48be-ae7a-e8f98ada145b",
    oldKey: "react-intro/ri-props-drilling",
    newKey: "react-effects-architecture/ri-props-drilling",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-effects-architecture",
    lessonSlug: "ri-props-drilling",
  },
  {
    lessonId: "1bcc96c6-1f62-4e77-89de-31621d1e9a3e",
    oldKey: "react-intro/ri-render-lists",
    newKey: "react-state-ui/ri-render-lists",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-state-ui",
    lessonSlug: "ri-render-lists",
  },
  {
    lessonId: "996af109-6f6c-4fd5-81cc-05fef8a83feb",
    oldKey: "react-intro/ri-rerender",
    newKey: "react-state-ui/ri-rerender",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-state-ui",
    lessonSlug: "ri-rerender",
  },
  {
    lessonId: "ad178385-c559-415a-aa42-18fb861e8b40",
    oldKey: "react-intro/ri-single-responsibility",
    newKey: "react-effects-architecture/ri-single-responsibility",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-effects-architecture",
    lessonSlug: "ri-single-responsibility",
  },
  {
    lessonId: "0db37e55-575b-4549-949f-1a031d628d3e",
    oldKey: "react-intro/ri-state-arrays",
    newKey: "react-state-ui/ri-state-arrays",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-state-ui",
    lessonSlug: "ri-state-arrays",
  },
  {
    lessonId: "15c5ac49-f772-4265-8519-60589918acf1",
    oldKey: "react-intro/ri-state-events",
    newKey: "react-state-ui/ri-state-events",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-state-ui",
    lessonSlug: "ri-state-events",
  },
  {
    lessonId: "dcfb706c-cae9-4f44-a0b9-0a76abc73dcf",
    oldKey: "react-intro/ri-state-objects",
    newKey: "react-state-ui/ri-state-objects",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-state-ui",
    lessonSlug: "ri-state-objects",
  },
  {
    lessonId: "c7513004-f906-464b-8747-c94dc34f5775",
    oldKey: "react-intro/ri-textarea-select",
    newKey: "react-state-ui/ri-textarea-select",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-state-ui",
    lessonSlug: "ri-textarea-select",
  },
  {
    lessonId: "bbfc08ae-83a6-4049-a529-2706986292d6",
    oldKey: "react-intro/ri-timers-react",
    newKey: "react-effects-architecture/ri-timers-react",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-effects-architecture",
    lessonSlug: "ri-timers-react",
  },
  {
    lessonId: "75112cd6-b9a9-42ee-83ab-257d5b91edbd",
    oldKey: "react-intro/ri-useeffect-basics",
    newKey: "react-effects-architecture/ri-useeffect-basics",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-effects-architecture",
    lessonSlug: "ri-useeffect-basics",
  },
  {
    lessonId: "9d145736-5886-451e-8efa-83f3c3bb6443",
    oldKey: "react-intro/ri-usestate-basics",
    newKey: "react-state-ui/ri-usestate-basics",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-state-ui",
    lessonSlug: "ri-usestate-basics",
  },
  {
    lessonId: "fdab327d-30a1-41f2-8464-2c8bc2ff8a0f",
    oldKey: "react-intro/ri-validation-react",
    newKey: "react-state-ui/ri-validation-react",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-state-ui",
    lessonSlug: "ri-validation-react",
  },
  {
    lessonId: "8e3a8888-ff42-468c-a822-ac0531cfd107",
    oldKey: "react-intro/ri-what-is-effect",
    newKey: "react-effects-architecture/ri-what-is-effect",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-effects-architecture",
    lessonSlug: "ri-what-is-effect",
  },
  {
    lessonId: "2fc66f8d-d289-4639-bd41-01926d9bbf82",
    oldKey: "react-intro/ri-why-state",
    newKey: "react-state-ui/ri-why-state",
    oldCourseSlug: "react-intro",
    newCourseSlug: "react-state-ui",
    lessonSlug: "ri-why-state",
  },
  {
    lessonId: "228f3164-ad7e-49c2-bfc1-7db46e786566",
    oldKey: "react-practical/rp-cart-reducer",
    newKey: "react-state-management/rp-cart-reducer",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-state-management",
    lessonSlug: "rp-cart-reducer",
  },
  {
    lessonId: "7a983463-0297-4453-a55f-8a447d46ac17",
    oldKey: "react-practical/rp-ch4-build",
    newKey: "react-state-management/rp-ch4-build",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-state-management",
    lessonSlug: "rp-ch4-build",
  },
  {
    lessonId: "83f1e8f8-a82b-4b05-9cb0-b63695f7eacf",
    oldKey: "react-practical/rp-ch4-quiz",
    newKey: "react-state-management/rp-ch4-quiz",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-state-management",
    lessonSlug: "rp-ch4-quiz",
  },
  {
    lessonId: "0c57a994-b6d2-4405-a8bb-a23f04d495b3",
    oldKey: "react-practical/rp-ch5-build",
    newKey: "react-state-management/rp-ch5-build",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-state-management",
    lessonSlug: "rp-ch5-build",
  },
  {
    lessonId: "31d0b704-ef23-4727-9b6e-aae537f11ab6",
    oldKey: "react-practical/rp-ch5-quiz",
    newKey: "react-state-management/rp-ch5-quiz",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-state-management",
    lessonSlug: "rp-ch5-quiz",
  },
  {
    lessonId: "6dafbffb-ec00-4b59-8afc-80192d5b2ca2",
    oldKey: "react-practical/rp-ch6-build",
    newKey: "react-state-management/rp-ch6-build",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-state-management",
    lessonSlug: "rp-ch6-build",
  },
  {
    lessonId: "245f5dc1-664a-4db8-9acf-138f88d129c5",
    oldKey: "react-practical/rp-ch6-quiz",
    newKey: "react-state-management/rp-ch6-quiz",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-state-management",
    lessonSlug: "rp-ch6-quiz",
  },
  {
    lessonId: "c08665f7-bcf3-47a4-bdc5-0625879756ca",
    oldKey: "react-practical/rp-ch7-build",
    newKey: "react-router-architecture/rp-ch7-build",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-router-architecture",
    lessonSlug: "rp-ch7-build",
  },
  {
    lessonId: "8debdb0f-b0ce-405e-948b-28c8e657b210",
    oldKey: "react-practical/rp-ch7-quiz",
    newKey: "react-router-architecture/rp-ch7-quiz",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-router-architecture",
    lessonSlug: "rp-ch7-quiz",
  },
  {
    lessonId: "8cff5084-868f-42d6-a8e8-71f475d1ddb8",
    oldKey: "react-practical/rp-ch8-build",
    newKey: "react-router-architecture/rp-ch8-build",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-router-architecture",
    lessonSlug: "rp-ch8-build",
  },
  {
    lessonId: "d03a3479-b74e-4d6d-9e9a-428d45bd8791",
    oldKey: "react-practical/rp-ch8-quiz",
    newKey: "react-router-architecture/rp-ch8-quiz",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-router-architecture",
    lessonSlug: "rp-ch8-quiz",
  },
  {
    lessonId: "c831ff87-f70a-46b8-842f-d9f82c16a215",
    oldKey: "react-practical/rp-composition",
    newKey: "react-router-architecture/rp-composition",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-router-architecture",
    lessonSlug: "rp-composition",
  },
  {
    lessonId: "44bafd49-3e14-42a0-bab6-bfdbd3f70df0",
    oldKey: "react-practical/rp-context-basics",
    newKey: "react-state-management/rp-context-basics",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-state-management",
    lessonSlug: "rp-context-basics",
  },
  {
    lessonId: "1ad5b27c-8ed7-4d66-8e77-59e80b6f499f",
    oldKey: "react-practical/rp-final-extend",
    newKey: "react-router-architecture/rp-final-extend",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-router-architecture",
    lessonSlug: "rp-final-extend",
  },
  {
    lessonId: "a7990174-cd74-4db7-9a06-4d7ce46d4247",
    oldKey: "react-practical/rp-final-mypage",
    newKey: "react-router-architecture/rp-final-mypage",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-router-architecture",
    lessonSlug: "rp-final-mypage",
  },
  {
    lessonId: "4504dfc5-7f51-43ba-95d5-b3a0b42ca4d4",
    oldKey: "react-practical/rp-final-next",
    newKey: "react-router-architecture/rp-final-next",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-router-architecture",
    lessonSlug: "rp-final-next",
  },
  {
    lessonId: "cbef73c1-a686-4e68-a790-d43021da3eaa",
    oldKey: "react-practical/rp-final-polish",
    newKey: "react-router-architecture/rp-final-polish",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-router-architecture",
    lessonSlug: "rp-final-polish",
  },
  {
    lessonId: "12b028c7-9d8c-4435-bf30-3fb6457d7db6",
    oldKey: "react-practical/rp-final-purchase",
    newKey: "react-router-architecture/rp-final-purchase",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-router-architecture",
    lessonSlug: "rp-final-purchase",
  },
  {
    lessonId: "7a28f435-3ef5-4be9-bef2-0c07fb6f8ae0",
    oldKey: "react-practical/rp-folder-by-feature",
    newKey: "react-router-architecture/rp-folder-by-feature",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-router-architecture",
    lessonSlug: "rp-folder-by-feature",
  },
  {
    lessonId: "cacdc20b-c443-49bf-b0c4-b87de4ba6d70",
    oldKey: "react-practical/rp-hook-rules",
    newKey: "react-state-management/rp-hook-rules",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-state-management",
    lessonSlug: "rp-hook-rules",
  },
  {
    lessonId: "33d09200-6f66-4956-9fce-4282154b0b23",
    oldKey: "react-practical/rp-hook-types",
    newKey: "react-state-management/rp-hook-types",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-state-management",
    lessonSlug: "rp-hook-types",
  },
  {
    lessonId: "f7a4ed2c-fa87-4120-879d-849a1da52d6a",
    oldKey: "react-practical/rp-link-navigate",
    newKey: "react-router-architecture/rp-link-navigate",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-router-architecture",
    lessonSlug: "rp-link-navigate",
  },
  {
    lessonId: "d7d5bc43-99e7-44d6-be8c-f76f29ed9cce",
    oldKey: "react-practical/rp-not-found",
    newKey: "react-router-architecture/rp-not-found",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-router-architecture",
    lessonSlug: "rp-not-found",
  },
  {
    lessonId: "4d97978d-c0c4-4b34-8b53-6675f157b780",
    oldKey: "react-practical/rp-presentational-container",
    newKey: "react-router-architecture/rp-presentational-container",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-router-architecture",
    lessonSlug: "rp-presentational-container",
  },
  {
    lessonId: "ab2385de-4df0-4766-bd02-620a1a29283f",
    oldKey: "react-practical/rp-props-drilling-pain",
    newKey: "react-state-management/rp-props-drilling-pain",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-state-management",
    lessonSlug: "rp-props-drilling-pain",
  },
  {
    lessonId: "98dd6048-dd0c-4191-a175-3ad99ae7edec",
    oldKey: "react-practical/rp-reducer-basics",
    newKey: "react-state-management/rp-reducer-basics",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-state-management",
    lessonSlug: "rp-reducer-basics",
  },
  {
    lessonId: "12fb4241-db4c-4ac2-851f-9f58ec6f8dbc",
    oldKey: "react-practical/rp-reducer-types",
    newKey: "react-state-management/rp-reducer-types",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-state-management",
    lessonSlug: "rp-reducer-types",
  },
  {
    lessonId: "48be4178-4fc1-4083-88fd-629519b0469e",
    oldKey: "react-practical/rp-reducer-vs-state",
    newKey: "react-state-management/rp-reducer-vs-state",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-state-management",
    lessonSlug: "rp-reducer-vs-state",
  },
  {
    lessonId: "afe7924c-c933-4236-903f-697a9712d964",
    oldKey: "react-practical/rp-routes-route",
    newKey: "react-router-architecture/rp-routes-route",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-router-architecture",
    lessonSlug: "rp-routes-route",
  },
  {
    lessonId: "5bf9161a-9e44-4b27-bab8-c45dcd4ea704",
    oldKey: "react-practical/rp-search-params",
    newKey: "react-router-architecture/rp-search-params",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-router-architecture",
    lessonSlug: "rp-search-params",
  },
  {
    lessonId: "73d75caf-5056-4a9b-a6c8-6d6c8e5276c3",
    oldKey: "react-practical/rp-spa-routing",
    newKey: "react-router-architecture/rp-spa-routing",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-router-architecture",
    lessonSlug: "rp-spa-routing",
  },
  {
    lessonId: "91a15953-a948-48f8-9ba1-3bf90a6bc76d",
    oldKey: "react-practical/rp-theme-context",
    newKey: "react-state-management/rp-theme-context",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-state-management",
    lessonSlug: "rp-theme-context",
  },
  {
    lessonId: "8c8f0626-b2d4-43fa-bcf1-417b5c4d6e34",
    oldKey: "react-practical/rp-url-params",
    newKey: "react-router-architecture/rp-url-params",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-router-architecture",
    lessonSlug: "rp-url-params",
  },
  {
    lessonId: "dfff10cf-b694-467d-b107-382793a0eb7b",
    oldKey: "react-practical/rp-usecontext",
    newKey: "react-state-management/rp-usecontext",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-state-management",
    lessonSlug: "rp-usecontext",
  },
  {
    lessonId: "1ed0f644-ca81-4bec-ad32-75353c7f338e",
    oldKey: "react-practical/rp-useform",
    newKey: "react-state-management/rp-useform",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-state-management",
    lessonSlug: "rp-useform",
  },
  {
    lessonId: "cc3d8adb-c01f-4ae2-9630-34cf4428e688",
    oldKey: "react-practical/rp-useitems",
    newKey: "react-state-management/rp-useitems",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-state-management",
    lessonSlug: "rp-useitems",
  },
  {
    lessonId: "2edcc9d9-6857-4eaa-96ae-014149814959",
    oldKey: "react-practical/rp-user-context",
    newKey: "react-state-management/rp-user-context",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-state-management",
    lessonSlug: "rp-user-context",
  },
  {
    lessonId: "51668c22-0d06-4e88-a298-a86e7732c99a",
    oldKey: "react-practical/rp-why-custom-hooks",
    newKey: "react-state-management/rp-why-custom-hooks",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-state-management",
    lessonSlug: "rp-why-custom-hooks",
  },
  {
    lessonId: "d09771c5-3d5a-4aaf-b5c3-261e909f18c9",
    oldKey: "react-practical/rp-why-reducer",
    newKey: "react-state-management/rp-why-reducer",
    oldCourseSlug: "react-practical",
    newCourseSlug: "react-state-management",
    lessonSlug: "rp-why-reducer",
  },
  {
    lessonId: "59ec2c97-a51a-40f7-8407-963bc1fcd898",
    oldKey: "typescript-intro/tsi-array-of-objects",
    newKey: "typescript-type-design/tsi-array-of-objects",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-type-design",
    lessonSlug: "tsi-array-of-objects",
  },
  {
    lessonId: "869f4e84-4252-4c7d-9376-71eaea80c58c",
    oldKey: "typescript-intro/tsi-builtin-generics",
    newKey: "typescript-type-design/tsi-builtin-generics",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-type-design",
    lessonSlug: "tsi-builtin-generics",
  },
  {
    lessonId: "6683bba6-f092-40bc-8d8e-1459fdae3c29",
    oldKey: "typescript-intro/tsi-ch4-build",
    newKey: "typescript-type-design/tsi-ch4-build",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-type-design",
    lessonSlug: "tsi-ch4-build",
  },
  {
    lessonId: "0884ac1f-eb15-4084-b598-b54fba3eaabc",
    oldKey: "typescript-intro/tsi-ch4-quiz",
    newKey: "typescript-type-design/tsi-ch4-quiz",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-type-design",
    lessonSlug: "tsi-ch4-quiz",
  },
  {
    lessonId: "de633aee-b028-45a5-8c68-82ae19256286",
    oldKey: "typescript-intro/tsi-ch5-build",
    newKey: "typescript-type-design/tsi-ch5-build",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-type-design",
    lessonSlug: "tsi-ch5-build",
  },
  {
    lessonId: "5909b6b8-38a9-4957-8dd3-2b28948dd5aa",
    oldKey: "typescript-intro/tsi-ch5-quiz",
    newKey: "typescript-type-design/tsi-ch5-quiz",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-type-design",
    lessonSlug: "tsi-ch5-quiz",
  },
  {
    lessonId: "cd4f019e-b310-4911-98db-9e4cc0ea0056",
    oldKey: "typescript-intro/tsi-ch6-build",
    newKey: "typescript-type-design/tsi-ch6-build",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-type-design",
    lessonSlug: "tsi-ch6-build",
  },
  {
    lessonId: "ad4fa0d7-d1c9-4f9b-a4cb-84fc1f7d2fcd",
    oldKey: "typescript-intro/tsi-ch6-quiz",
    newKey: "typescript-type-design/tsi-ch6-quiz",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-type-design",
    lessonSlug: "tsi-ch6-quiz",
  },
  {
    lessonId: "123963a5-8da8-4d99-846f-3006f9d0e27f",
    oldKey: "typescript-intro/tsi-ch7-build",
    newKey: "typescript-migration/tsi-ch7-build",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-migration",
    lessonSlug: "tsi-ch7-build",
  },
  {
    lessonId: "c0788a36-61c4-4620-9708-76648cc8270e",
    oldKey: "typescript-intro/tsi-dom-types",
    newKey: "typescript-migration/tsi-dom-types",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-migration",
    lessonSlug: "tsi-dom-types",
  },
  {
    lessonId: "b50d3d73-ee5e-42c2-b309-0fdaa1a1517a",
    oldKey: "typescript-intro/tsi-final-extend",
    newKey: "typescript-migration/tsi-final-extend",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-migration",
    lessonSlug: "tsi-final-extend",
  },
  {
    lessonId: "98c16b6d-7cae-494f-b1f6-ec6b47282bbd",
    oldKey: "typescript-intro/tsi-final-next",
    newKey: "typescript-migration/tsi-final-next",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-migration",
    lessonSlug: "tsi-final-next",
  },
  {
    lessonId: "26370b89-6f97-485c-98d8-5d2ff7fbd983",
    oldKey: "typescript-intro/tsi-fix-errors",
    newKey: "typescript-migration/tsi-fix-errors",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-migration",
    lessonSlug: "tsi-fix-errors",
  },
  {
    lessonId: "4fca20df-027c-4c37-a310-bf77784cd93d",
    oldKey: "typescript-intro/tsi-generic-arrays",
    newKey: "typescript-type-design/tsi-generic-arrays",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-type-design",
    lessonSlug: "tsi-generic-arrays",
  },
  {
    lessonId: "e795b2f5-301f-4846-ad7d-ece657e71dd9",
    oldKey: "typescript-intro/tsi-generic-constraints",
    newKey: "typescript-type-design/tsi-generic-constraints",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-type-design",
    lessonSlug: "tsi-generic-constraints",
  },
  {
    lessonId: "ce4d8a7e-112a-4907-9a3e-fa01f76d4577",
    oldKey: "typescript-intro/tsi-generic-functions",
    newKey: "typescript-type-design/tsi-generic-functions",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-type-design",
    lessonSlug: "tsi-generic-functions",
  },
  {
    lessonId: "017317fb-0961-409b-a8db-045278aeaaea",
    oldKey: "typescript-intro/tsi-interface-basics",
    newKey: "typescript-type-design/tsi-interface-basics",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-type-design",
    lessonSlug: "tsi-interface-basics",
  },
  {
    lessonId: "c147b9cb-d060-49e0-8a51-b7161788bca9",
    oldKey: "typescript-intro/tsi-interface-vs-type",
    newKey: "typescript-type-design/tsi-interface-vs-type",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-type-design",
    lessonSlug: "tsi-interface-vs-type",
  },
  {
    lessonId: "973d2ed2-f70a-451e-a3ab-563128ad9310",
    oldKey: "typescript-intro/tsi-literal-types",
    newKey: "typescript-type-design/tsi-literal-types",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-type-design",
    lessonSlug: "tsi-literal-types",
  },
  {
    lessonId: "5fc0a5e5-6b01-46ee-b6c4-78e7edca43e0",
    oldKey: "typescript-intro/tsi-migrate-data",
    newKey: "typescript-migration/tsi-migrate-data",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-migration",
    lessonSlug: "tsi-migrate-data",
  },
  {
    lessonId: "17ae72ca-49af-4c19-a5eb-b881ea72b716",
    oldKey: "typescript-intro/tsi-migrate-plan",
    newKey: "typescript-migration/tsi-migrate-plan",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-migration",
    lessonSlug: "tsi-migrate-plan",
  },
  {
    lessonId: "3ecc3fdd-896a-4584-b68c-9f965f543b53",
    oldKey: "typescript-intro/tsi-migrate-utils",
    newKey: "typescript-migration/tsi-migrate-utils",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-migration",
    lessonSlug: "tsi-migrate-utils",
  },
  {
    lessonId: "d9c7fdf4-43f4-4bde-97be-e2a87809009f",
    oldKey: "typescript-intro/tsi-narrowing-in",
    newKey: "typescript-type-design/tsi-narrowing-in",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-type-design",
    lessonSlug: "tsi-narrowing-in",
  },
  {
    lessonId: "bc07b018-9375-4a84-9ea9-becd4e388b2e",
    oldKey: "typescript-intro/tsi-narrowing-typeof",
    newKey: "typescript-type-design/tsi-narrowing-typeof",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-type-design",
    lessonSlug: "tsi-narrowing-typeof",
  },
  {
    lessonId: "1408c6a2-fd2e-4b91-b09c-43169bd19d74",
    oldKey: "typescript-intro/tsi-nested-types",
    newKey: "typescript-type-design/tsi-nested-types",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-type-design",
    lessonSlug: "tsi-nested-types",
  },
  {
    lessonId: "344d9d29-3e6f-4db3-97e4-3bb6746dd93d",
    oldKey: "typescript-intro/tsi-optional-props",
    newKey: "typescript-type-design/tsi-optional-props",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-type-design",
    lessonSlug: "tsi-optional-props",
  },
  {
    lessonId: "11978f52-9508-48b4-a6a8-d974d07b211a",
    oldKey: "typescript-intro/tsi-readonly",
    newKey: "typescript-type-design/tsi-readonly",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-type-design",
    lessonSlug: "tsi-readonly",
  },
  {
    lessonId: "f22b4271-30ea-4351-b7ac-5289ef330a69",
    oldKey: "typescript-intro/tsi-status-union",
    newKey: "typescript-type-design/tsi-status-union",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-type-design",
    lessonSlug: "tsi-status-union",
  },
  {
    lessonId: "184f9089-e331-4656-9eb1-c717ae0be2ff",
    oldKey: "typescript-intro/tsi-tsconfig-basics",
    newKey: "typescript-migration/tsi-tsconfig-basics",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-migration",
    lessonSlug: "tsi-tsconfig-basics",
  },
  {
    lessonId: "dc5252a5-b22c-4422-b98f-c7921048cd2c",
    oldKey: "typescript-intro/tsi-union-basics",
    newKey: "typescript-type-design/tsi-union-basics",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-type-design",
    lessonSlug: "tsi-union-basics",
  },
  {
    lessonId: "b5ec1554-3f3f-4f64-9884-3db43821e03d",
    oldKey: "typescript-intro/tsi-union-practice",
    newKey: "typescript-type-design/tsi-union-practice",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-type-design",
    lessonSlug: "tsi-union-practice",
  },
  {
    lessonId: "44479622-8180-43dd-a527-12b9cccc9508",
    oldKey: "typescript-intro/tsi-why-generics",
    newKey: "typescript-type-design/tsi-why-generics",
    oldCourseSlug: "typescript-intro",
    newCourseSlug: "typescript-type-design",
    lessonSlug: "tsi-why-generics",
  },
]) satisfies readonly TypescriptReactNextjsCourseSplitLessonAlias[];

export const TYPESCRIPT_REACT_NEXTJS_OLD_TO_NEW_LESSON_KEY: Readonly<
  Record<string, string>
> = Object.freeze(
  Object.fromEntries(
    TYPESCRIPT_REACT_NEXTJS_LESSON_ALIASES.map(({ oldKey, newKey }) => [
      oldKey,
      newKey,
    ]),
  ),
);

export const TYPESCRIPT_REACT_NEXTJS_NEW_TO_OLD_LESSON_KEY: Readonly<
  Record<string, string>
> = Object.freeze(
  Object.fromEntries(
    TYPESCRIPT_REACT_NEXTJS_LESSON_ALIASES.map(({ oldKey, newKey }) => [
      newKey,
      oldKey,
    ]),
  ),
);

export const TYPESCRIPT_REACT_NEXTJS_NEW_COURSE_TITLES: Readonly<
  Record<string, string>
> = Object.freeze({
  "nextjs-fullstack": "Next.jsフルスタック：サーバー・データ取得・API",
  "nextjs-production": "Next.js公開設計：SEO・画像最適化・デプロイ",
  "react-effects-architecture": "React設計：useEffectとコンポーネント分割",
  "react-router-architecture": "React Routerとアプリ設計",
  "react-state-management": "React状態管理：カスタムフック・Context・Reducer",
  "react-state-ui": "Reactで状態・フォーム・リストを扱う",
  "typescript-migration": "JavaScriptをTypeScriptへ移行する",
  "typescript-type-design": "TypeScript型設計：オブジェクト・状態・ジェネリクス",
});

/** Stable static identity shared before and after the ownership transaction. */
export function canonicalTypescriptReactNextjsLessonKey(key: string): string {
  return TYPESCRIPT_REACT_NEXTJS_NEW_TO_OLD_LESSON_KEY[key] ?? key;
}

/** Both public keys for a moved lesson; one key for an unaffected lesson. */
export function typescriptReactNextjsLessonKeyAliases(
  key: string,
): readonly string[] {
  const canonical = canonicalTypescriptReactNextjsLessonKey(key);
  const next = TYPESCRIPT_REACT_NEXTJS_OLD_TO_NEW_LESSON_KEY[canonical];
  return next ? [canonical, next] : [canonical];
}
